import * as React from 'react';
import PropTypes from 'prop-types';

class ScoringRound extends React.Component {
    constructor(props) {
        super(props);

        let scores = new Array(this.props.players.length).fill(null);
        this.state = {
            scores,
            submitDisabled: true,
            sounds: true,
        };

        this.changePlayerScore = this.changePlayerScore.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.resetBids = this.resetBids.bind(this);
        this.checkScores = this.checkScores.bind(this);
        this.toggleSounds = this.toggleSounds.bind(this);

    }

    speakScore(playerId, score) {
        let playerBid = this.props.bids[playerId];
        console.log('Player score: ' + score + ', playerBid ' + playerBid);

        let playerName = this.props.players[playerId]['name'];
        let speakThis = null;

        if (score === this.props.bids[playerId]) {
            speakThis = playerName + ' OK ';
        } else {
            speakThis = playerName + ' FAIL ';
        }
        let synthesis = window.speechSynthesis;
        let utterance = new SpeechSynthesisUtterance(speakThis);

        synthesis.speak(utterance);
    }

    changePlayerScore(player, event) {
        let scores = this.state.scores.slice();
        scores[player] = parseInt(event.target.value, 10);

        this.setState({ scores });
        this.checkScores(scores);

        let sounds = this.state.sounds;

        if (sounds) {
            this.speakScore(player, scores[player]);
        }
    }

    toggleSounds() {
        let sounds = this.state.sounds;
        console.log(sounds);

        sounds = sounds != true;

        console.log("Setting sound state to: " + sounds);

        this.setState({ sounds });
    }

    checkScores(scores) {
        let message = null;
        let submitDisabled = true;

        let submittedScoresCount = scores.filter((el) => el !== null).length;

        if (submittedScoresCount < this.props.players.length) {
            message = 'Asteptam dupa toti jucatorii sa termine licitatia.';
        } else {
            let scoresSum = 0;
            scores.forEach((score) => {
                scoresSum += score;
            });

            if (scoresSum !== this.props.cardsCount) {
                message = `Totalul scorurilor nu este ${this.props.cardsCount}`;
            } else {
                submitDisabled = false;
            }
        }

        this.setState({ message, submitDisabled });
    }

    handleSubmit() {
        this.props.onSubmit(this.state.scores);
    }

    resetBids() {
        if (window.confirm('Esti sigur ca vrei sa resetezi runda ?')) {
            this.props.onReset();
        }
    }

    renderScoreOptions(playerIndex, player) {
        let options = [];
        for (let i = 0; i <= this.props.cardsCount; i++) {
            options.push(i);
        }

        return (
            options.map(i => {
                return (
                    <div className="form-check form-check-inline" key={i}>
                        <input
                            className="form-check-input"
                            type="radio"
                            name={ "player" + playerIndex }
                            id={ "player" + playerIndex + i}
                            value={ i }
                            onChange={ (e) => this.changePlayerScore(playerIndex, e) }/>
                        <label key={i} htmlFor={"player" + playerIndex + i}
                               className={(
                                   i === this.props.bids[player.id]
                                       ? 'form-check-label font-weight-bold text-success'
                                       : 'form-check-label font-weight-bold text-danger'

                               )}>
                            {i} {i === this.props.bids[player.id] ? "(OK)" : "(NOK)" }
                        </label>
                    </div>
                );
            })
        )
    }

    render() {
        return (
                <div className="card">
                    <div className="card-header">
                        Rezultate Runda
                    </div>

                    <div className="card-body">
                        { this.props.players.map((player, index) => {
                            return (
                                <div key={ index } className="d-block">
                                    { player.name }:
                                    <br/>
                                    { this.renderScoreOptions(index, player) }
                                    <br/><br/>
                                </div>
                            )
                        }) }

                        <div className="message">
                            { this.state.message }
                        </div>

                        <button
                            className="btn btn-sm btn-danger mr-2"
                            onClick={ this.resetBids }
                        >
                            Reseteaza licitatia
                        </button>

                        <button
                            className="btn btn-sm btn-success"
                            onClick={ this.handleSubmit }
                            disabled={ this.state.submitDisabled }
                        >
                            Termina runda
                        </button>
                    </div>

                    <div className="card-footer">
                        <button
                            className="btn btn-sm btn-secondary"
                            onClick={ this.toggleSounds }
                        >
                            Opreste sunete
                        </button>
                    </div>
                </div>
        );
    }
}

ScoringRound.propTypes = {
    cardsCount: PropTypes.number.isRequired,
    players: PropTypes.arrayOf(PropTypes.object).isRequired,
    bids: PropTypes.arrayOf(PropTypes.number).isRequired,
    onSubmit: PropTypes.func.isRequired,
    onReset: PropTypes.func.isRequired
};

export default ScoringRound;



// WEBPACK FOOTER //
// ./src/components/ScoringRound.js